var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFdImgCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 158 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.65,78.183c3.041,-0.173 6.815,-2.236 9.749,-3.149c3.473,-1.077 6.959,-2.113 10.459,-3.109c12.186,-3.467 24.502,-6.421 36.948,-8.863c1.162,-0.228 2.325,-0.451 3.491,-0.669c-1.815,-3.922 -4.628,-7.299 -8.156,-9.794c0.09,-0.859 0.136,-1.722 0.138,-2.585c0,-13.644 -10.904,-24.705 -24.36,-24.705c-4.142,-0.004 -8.216,1.065 -11.822,3.104c-9.523,-6.265 -21.954,-10.057 -35.554,-10.057c-19.325,0 -36.29,7.656 -45.903,19.185l45.179,7.633l27.71,4.679c-31.589,0.943 -63.276,1.88 -94.774,-0.333c-8.575,8.297 -10.081,21.501 -3.595,31.516c0,0.494 0.021,0.984 0.058,1.47c0.803,0.23 1.577,0.453 2.272,0.598c11.158,2.358 22.387,4.33 33.688,5.918c-8.328,5.135 -18.469,5.862 -28.075,8.036c4.651,3.84 10.968,6.193 17.929,6.193l103.648,0c11.223,0 20.32,-7.813 20.32,-17.452c1.684,-2.777 2.807,-5.858 3.303,-9.068c-20.767,2.005 -41.794,0.264 -62.653,1.452Z",
    style: {
      fill: "#8776d9",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.445,72.626c0.023,-8.062 -3.879,-15.631 -10.46,-20.289c0.09,-0.858 0.136,-1.72 0.138,-2.583c0,-13.644 -10.909,-24.701 -24.359,-24.701c-4.143,-0.004 -8.217,1.064 -11.824,3.102c-9.523,-6.267 -21.955,-10.06 -35.555,-10.06c-22.122,0 -41.163,10.04 -49.608,24.436c-0.469,-0.027 -0.941,-0.042 -1.417,-0.042c-13.452,0 -24.36,11.061 -24.36,24.705c-0.009,4.819 1.383,9.537 4.008,13.579c0,12.276 11.586,22.228 25.873,22.228l103.65,0c11.222,0 20.319,-7.815 20.319,-17.454c2.36,-3.896 3.604,-8.366 3.595,-12.921Z",
    style: {
      fill: "#8776d9",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M123.782,6.758l-0.163,2.192c-0.024,0.297 -0.593,7.382 -4.788,15.662c-3.6,7.102 -10.605,16.351 -23.832,21.55c-1.032,0.408 -2.103,0.788 -3.213,1.142l-1.239,-3.888c3.109,-0.978 6.104,-2.288 8.933,-3.907c6.742,-3.893 11.983,-9.449 15.638,-16.599c1.94,-3.806 3.322,-7.872 4.104,-12.072l-15.048,0l0,-4.08l19.608,0Z",
    style: {
      fill: "#fde194",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.379,46.164c13.224,-5.198 20.232,-14.446 23.83,-21.547c4.195,-8.28 4.766,-15.36 4.788,-15.663l0.163,-2.191l1.68,0l-0.163,2.191c-0.022,0.298 -0.593,7.383 -4.788,15.663c-3.6,7.101 -10.606,16.349 -23.83,21.547c-1.032,0.408 -2.104,0.79 -3.216,1.145l-0.163,-0.511c0.579,-0.207 1.146,-0.418 1.699,-0.634Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.902,43.416l-1.238,3.888c-1.112,-0.355 -2.184,-0.737 -3.216,-1.145c-13.224,-5.198 -20.232,-14.445 -23.83,-21.547c-4.195,-8.28 -4.766,-15.36 -4.788,-15.662l-0.163,-2.192l19.599,0l0,4.08l-15.051,0c0.787,4.201 2.173,8.266 4.116,12.072c3.655,7.15 8.895,12.706 15.636,16.596c2.83,1.621 5.825,2.932 8.935,3.91Z",
    style: {
      fill: "#fde194",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.066,46.164c-13.224,-5.198 -20.232,-14.446 -23.83,-21.547c-4.195,-8.28 -4.766,-15.36 -4.788,-15.663l-0.163,-2.191l-1.68,0l0.163,2.191c0.022,0.298 0.593,7.383 4.788,15.663c3.6,7.101 10.606,16.349 23.83,21.547c1.032,0.408 2.104,0.79 3.216,1.145l0.163,-0.511c-0.578,-0.207 -1.144,-0.418 -1.699,-0.634Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.364,81l0,22.001l-45.281,0l0,-22.001l1.44,-1.92c14.674,-5.208 17.647,-18.79 18.24,-24.163c0.089,-0.743 0.139,-1.489 0.151,-2.237l5.6,0c0.012,0.748 0.063,1.494 0.151,2.237c0.602,5.373 3.576,18.96 18.24,24.163l1.459,1.92Z",
    style: {
      fill: "#fde194",
      fillRule: "nonzero"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.083,
    y: 81,
    width: 45.281,
    height: 2.76
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.923,79.08c14.674,-5.208 17.648,-18.79 18.24,-24.163c0.089,-0.743 0.139,-1.489 0.152,-2.237l-2.4,0c-0.013,0.748 -0.063,1.494 -0.152,2.237c-0.602,5.373 -3.576,18.96 -18.24,24.163l-1.44,1.92l0,22.001l2.4,0l0,-22.001l1.44,-1.92Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.205,6.758l4.061,0l0,4.08l-3.701,0c-0.146,-1.344 -0.266,-2.704 -0.36,-4.08Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.902,43.416l-1.238,3.888c-1.112,-0.355 -2.184,-0.737 -3.216,-1.145c-1.698,-2.073 -3.198,-4.3 -4.481,-6.653c2.83,1.621 5.825,2.932 8.935,3.91Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.545,43.416c3.109,-0.978 6.104,-2.288 8.933,-3.907c-1.284,2.352 -2.784,4.581 -4.481,6.655c-1.032,0.408 -2.103,0.789 -3.214,1.142l-1.238,-3.89Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.24,6.758c-0.094,1.376 -0.214,2.736 -0.36,4.08l-3.698,0l0,-4.08l4.058,0Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.675,54.917c-1.95,0.377 -3.953,0.377 -5.902,0c0.088,-0.743 0.139,-1.489 0.151,-2.237l5.599,0c0.013,0.748 0.063,1.494 0.152,2.237Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.685,0c0.103,30.254 13.063,54.72 29.04,54.72c15.977,0 28.934,-24.466 29.04,-54.72l-58.08,0Z",
    style: {
      fill: "#fde194",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.845,0l-5.16,0c0.103,30.254 13.063,54.72 29.04,54.72c0.864,-0.002 1.727,-0.075 2.58,-0.218c-14.77,-2.468 -26.362,-25.894 -26.46,-54.502Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 63.324,
    y: 89.422,
    width: 30.799,
    height: 7.92,
    style: {
      fill: "#8776d9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.764,90.502l29.359,0l0,-1.08l-30.799,0l0,7.92l1.44,0l0,-6.84Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFdImgCap);
export default __webpack_public_path__ + "static/media/fd_img_cap.4005b0e8.svg";
export { ForwardRef as ReactComponent };